<template>
  <div class="roomInfo">
    <div class="create" v-if="roomType === ''">
      <div class="createBtn" @click="createBtn(1)">创建交易群信息<i class="el-icon-circle-plus-outline"></i></div>
      <div class="createBtn" @click="createBtn(2)">创建沟通群信息<i class="el-icon-circle-plus-outline"></i></div>
    </div>
    <div class="communicate" v-else-if="roomType ===1">
      <el-form class="communicateForm" label-position="left" label-width="80px" :model="communicateForm"
               v-if="communicateEdit">
        <el-form-item label="商品编号：">
          <el-input v-model="communicateForm.goods_no" placeholder="请输入商品编号"></el-input>
        </el-form-item>
        <el-form-item label="游戏名称：">
          <el-select v-model="communicateForm.game_id" placeholder="请选择游戏名称" filterable @change="gameChange">
            <el-option :label="item.game_name" :value="item.game_id" v-for="(item,index) in gameList"
                       :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`${item.cat_name}:`" v-for="(item,index) in category" :key="index">
          <el-select v-model="communicateForm.area_id" :placeholder="`请选择${item.cat_name}`"  v-if="index == 0"
                     @change="categoryChange" >
            <el-option :label="items.name" :value="items.id" v-for="(items) in item.entries" :key="items.id"
                       ></el-option>
          </el-select>
          <el-select v-model="communicateForm.server_id" :placeholder="`请选择${item.cat_name}`"  v-else-if="index == 1">
            <el-option :label="items.name" :value="items.id" v-for="(items) in item.entries"
                       :key="items.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交易价格：">
          <el-input type="number" v-model="communicateForm.goods_price" placeholder="请输入交易价格"></el-input>
        </el-form-item>
        <el-form-item label="服务客服：" >
          <el-input v-model="communicateForm.admin_name" placeholder="请输入服务客服"></el-input>
        </el-form-item>
      </el-form>
      <div class="communicateForm" v-else>
        <div class="item">
          <div class="label">商品编号：</div>
          <div class="text">{{ communicateForm.goods_no }}</div>
        </div>
        <div class="item">
          <div class="label">游戏名称：</div>
          <div class="text">{{ communicateForm.game_name }}</div>
        </div>
        <div class="item">
          <div class="label">游戏大区：</div>
          <div class="text">{{ communicateForm.area_name }}</div>
        </div>
        <div class="item">
          <div class="label">服务器：</div>
          <div class="text">{{ communicateForm.server_name }}</div>
        </div>
        <div class="item">
          <div class="label">交易价格：</div>
          <div class="text">{{ communicateForm.goods_price }}</div>
        </div>
        <div class="item">
          <div class="label">服务客服：</div>
          <div class="text">{{ communicateForm.admin_name }}</div>
        </div>
      </div>
      <div class="btnGroup" :style="{'justify-content':communicateEdit?'space-between':'flex-end'}">
        <div class="operating" v-if="communicateEdit">
          <div class="operating-btn" @click="communicateEdit = !communicateEdit">取消</div>
          <div class="operating-btn" @click="roomextAdd">确认</div>
        </div>
        <div class="edit" @click="communicateEditClick()">修改<i class="el-icon-edit-outline"></i></div>
      </div>
      <div class="backBtn" @click="back"  v-if="isBack">
        返回
      </div>
    </div>
    <div class="groupChat" v-else-if="roomType === 2">
      <el-form class="groupChatForm" label-position="top" label-width="75px" :model="groupChatForm"
               v-if="groupChatEdit">
        <el-form-item label="标题：">
          <el-input v-model="groupChatForm.room_name" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="群聊信息：">
          <el-input
            type="textarea"
            :rows="5"
            class="groupChatForm-info"
            placeholder="请输入群聊信息"
            v-model="groupChatForm.room_mark">
          </el-input>
        </el-form-item>
      </el-form>
      <div class="groupChatForm" v-else>
        <div class="title">
          <div class="label">标题：</div>
          <div class="text">{{ groupChatForm.room_name }}</div>
        </div>
        <div class="info">
          <div class="label">群聊信息：</div>
          <div class="text">{{ groupChatForm.room_mark }}</div>
        </div>
      </div>
      <div class="btnGroup" :style="{'justify-content':groupChatEdit?'space-between':'flex-end'}">
        <div class="operating" v-if="groupChatEdit">
          <div class="operating-btn" @click="groupChatEdit = !groupChatEdit">取消</div>
          <div class="operating-btn" @click="roomextAdd">确认</div>
        </div>
        <div class="edit" @click="groupChatEdit = !groupChatEdit">修改<i class="el-icon-edit-outline"></i></div>
      </div>
      <div class="backBtn" @click="back" v-if="isBack">
        返回
      </div>
    </div>
  </div>
</template>

<script>
import {
  apiRoomextInfo,
  apiGameList,
  apiRoomextAdd,
  apiRoomextEdit,
  imGameCategory,
  imGamePcate
} from "@/request/API"

export default {
  name: "index",
  props: {},
  components: {},
  data() {
    return {
      room_id: this.$route.query.roomid,
      roomType: '',
      //交易群
      groupChatForm: {
        room_name: '',
        room_mark: '',
      },
      groupChatEdit: true,
      //沟通群
      communicateForm: {
        goods_no: '',
        game_id: '',
        area_id: '',
        server_id: '',
        goods_price: '',
        admin_name: '',
      },
      communicateEdit: true,
      //游戏列表
      gameList: [],
      //游戏分类属性
      category: [],
      isBack:true,
      apiInfo: apiRoomextAdd,
    }
  },
  methods: {
    /**
     * 创建房间信息类型
     */
    createBtn(type) {
      this.roomType = type
      if (this.roomType === 1) {
        for (let communicateFormKey in this.communicateForm) {
          if (this.communicateForm[communicateFormKey] !== '') {
            this.communicateEdit = false
          }
        }
        this.communicateEdit ? this.getGameList() : ''
      } else if (this.roomType === 2) {
        for (let groupChatFormKey in this.groupChatForm) {
          if (this.groupChatForm[groupChatFormKey] !== '') {
            this.groupChatEdit = false
          }
        }
      }
    },
    /**
     * 获取房间信息
     * @param room_id
     */
    roomextInfo(room_id) {
      apiRoomextInfo({
        room_id
      }).then(res => {
        this.groupChatForm = res.data.alternate
        this.communicateForm = res.data.medium
        this.createBtn(res.data.type)
        res.data.id !== 0 ? this.apiInfo = apiRoomextEdit : this.apiInfo = apiRoomextAdd
        res.data.id !== 0 ? this.isBack = false : this.isBack = true
      })
    },
    /**
     * 获取游戏列表
     */
    getGameList() {
      apiGameList({}).then(res => {
        this.gameList = res.data
      })
    },
    /**
     * 房间拓展信息添加
     */
    roomextAdd() {
      this.apiInfo({
        room_id: this.room_id,
        type: this.roomType,
        goods_no: this.communicateForm.goods_no,
        game_id: this.communicateForm.game_id,
        area_id: this.communicateForm.area_id,
        server_id: this.communicateForm.server_id,
        goods_price: this.communicateForm.goods_price,
        admin_name: this.communicateForm.admin_name,
        room_name: this.groupChatForm.room_name,
        room_mark: this.groupChatForm.room_mark,
      }).then(res => {
        this.roomType === 1 ? this.communicateEdit = false : this.groupChatEdit = false
        if (this.apiInfo === apiRoomextAdd) {
          this.apiInfo = apiRoomextEdit
        }
        this.communicateForm = res.data.medium
        this.groupChatForm = res.data.alternate
        this.isBack = false
      })

    },
    /**
     * 选中游戏
     * @param val
     */
    gameChange(val) {
      this.communicateForm.area_id = ''
      this.communicateForm.server_id = ''
      imGameCategory({
        game_id: val
      }).then(res => {
        this.category = res.data
      })
    },
    /**
     * 游戏分类
     * @param val
     */
    categoryChange(val) {
      this.communicateForm.server_id = ''
        imGamePcate({
          game_id: this.communicateForm.game_id,
          pid: val
        }).then(res => {
          for (let resKey in res.data.list) {
            this.category.forEach((item,index) => {
              if (item.cat_id === parseInt(resKey)) {
                item.entries.splice(0, item.entries.length)
                res.data.list[resKey].forEach((keyItem, keyIndex) => {
                  item.entries.push(keyItem)
                })
              }
            })
          }
        })
    },

    /**
     * 返回
     */
    back(){
      this.roomType = ''
    },
    /**
     * 交易群 信息编辑
     */
    communicateEditClick(){
      this.communicateEdit = !this.communicateEdit
      this.getGameList()
    }
  },
  watch: {},
  created() {
    this.roomextInfo(this.$route.query.roomid)
  },
  mounted() {

  }
}
</script>

<style scoped lang="less">
/*在谷歌下移除input[number]的上下箭头*/
.el-input__inner[type="number"]::-webkit-outer-spin-button,
/deep/ .el-input__inner[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0;
}

/*在firefox下移除input[number]的上下箭头*/
.el-input__inner[type="number"] {
  -moz-appearance: textfield;
}

.roomInfo {
  width: 280px;
  height: 335px;
  position: absolute;
  left: 0;
  top: 0;
  background: #f7f8fa;

  .create {
    display: flex;
    flex-direction: column;
    align-items: center;

    .createBtn {
      width: 160px;
      height: 35px;
      background: #FFFFFF;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #A4ABB8;
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #A4ABB8;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      i {
        margin: 0 0 0 5px;
      }
    }

    .createBtn:first-of-type {
      margin: 52px 0 15px;
    }

    .createBtn:hover {
      color: var(--primary, #FF5A1F);
      border: 1px solid var(--primary, #FF5A1F);
    }
  }

  .groupChat {
    padding: 20px 20px 0;

    .groupChatForm {
      /deep/ .el-form-item {
        margin: 0 0 10px;
      }

      /deep/ .el-form-item__label {
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #A4ABB8;
        line-height: 16px;
        padding: 0 0 2px;
      }

      /deep/ .el-input__inner {
        height: 26px;
        background: #FFFFFF;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        border: 1px solid #DEE3EC;
      }

      /deep/ .el-input__inner:focus {
        border-color: var(--primary, #FF5A1F);
        box-shadow: none;
      }

      /deep/ .groupChatForm-info {
        .el-textarea__inner {
          resize: none;
        }
      }

      .title, .info {
        .label {
          width: 100%;
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #A4ABB8;
          line-height: 16px;
          word-break: break-all;
          margin: 0 0 2px;
        }

        .text {
          word-break: break-all;
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #1A1D24;
          line-height: 16px;
        }
      }

      .title {
        margin: 0 0 10px;
        min-height: 44px;
      }

      .info {
        min-height: 117px;

      }
    }

    .btnGroup {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 25px 0 0;

      .operating {
        display: flex;
        align-items: center;

        .operating-btn {
          width: 70px;
          height: 25px;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #A4ABB8;
          font-size: 12px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #A4ABB8;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }

        .operating-btn:first-of-type {
          margin: 0 10px 0 0;
        }

        .operating-btn:hover {
          color: var(--primary, #FF5A1F);
          border: 1px solid var(--primary, #FF5A1F);
        }
      }

      .edit {
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #D4DAE3;
        cursor: pointer;
        line-height: 27px;
      }

      .edit:hover {
        color: var(--primary, #FF5A1F);
      }
    }

    .backBtn{
      margin: 20px 0 0;
      font-size: 12px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #D4DAE3;
      cursor: pointer;
      line-height: 27px;
      display: flex;
      justify-content: flex-end;
    }
    .backBtn:hover {
      color: var(--primary, #FF5A1F);
    }
  }

  .communicate {
    padding: 20px 20px 0;

    .communicateForm {
      /deep/ .el-form-item {
        margin: 0 0 12px;
        display: flex;
        align-items: center;
      }

      /deep/ .el-form-item__content {
        margin: 0 !important;
        line-height: 26px;
      }

      /deep/ .el-input__icon {
        line-height: 26px;
      }

      /deep/ .el-form-item__label {
        flex-shrink: 0;
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #A4ABB8;
        line-height: 16px;
        padding: 0 0 2px;
      }

      /deep/ .el-input__inner {
        height: 26px;
        background: #FFFFFF;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        border: 1px solid #DEE3EC;
      }

      /deep/ .el-input__inner:focus {
        border-color: var(--primary, #FF5A1F);
        box-shadow: none;
      }

      .item{
        margin: 0 0 10px;
        display: flex;
        align-items: center;

        .label {
          min-width: 75px;
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #A4ABB8;
          line-height: 16px;
          word-break: break-all;
          margin: 0 0 2px;
        }

        .text {
          word-break: break-all;
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #1A1D24;
          line-height: 16px;
        }
      }

    }

    .btnGroup {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 25px 0 0;

      .operating {
        display: flex;
        align-items: center;

        .operating-btn {
          width: 70px;
          height: 25px;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #A4ABB8;
          font-size: 12px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #A4ABB8;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }

        .operating-btn:first-of-type {
          margin: 0 10px 0 0;
        }

        .operating-btn:hover {
          color: var(--primary, #FF5A1F);
          border: 1px solid var(--primary, #FF5A1F);
        }
      }

      .edit {
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #D4DAE3;
        cursor: pointer;
        line-height: 27px;
      }

      .edit:hover {
        color: var(--primary, #FF5A1F);
      }
    }

    .backBtn{
      margin: 20px 0 0;
      font-size: 12px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #D4DAE3;
      cursor: pointer;
      line-height: 27px;
      display: flex;
      justify-content: flex-end;
    }
    .backBtn:hover {
      color: var(--primary, #FF5A1F);
    }
  }

}

</style>
